import React from 'react';
import LogoGleeph from '../assets/GleephWhite.svg'

export default class DefaultCover extends React.Component {
    render(){
        return <div className={"DefaultCover"}>
            <img src={LogoGleeph}/>
        </div>
    }
}